<div class="footer">
  <img nz-image nzSrc="/assets/images/footer.jpg" alt="NFL Footer" />
</div>
